import { render } from "./FavoriteSession.vue?vue&type=template&id=21ddc8fe&scoped=true"
import script from "./FavoriteSession.vue?vue&type=script&lang=js"
export * from "./FavoriteSession.vue?vue&type=script&lang=js"

import "./FavoriteSession.vue?vue&type=style&index=0&id=21ddc8fe&scoped=true&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ddc8fe"]])

export default __exports__